
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2rhyz_1e3g2_9",
  "input": "awsui_input_2rhyz_1e3g2_13",
  "input-readonly": "awsui_input-readonly_2rhyz_1e3g2_62",
  "input-invalid": "awsui_input-invalid_2rhyz_1e3g2_106",
  "input-warning": "awsui_input-warning_2rhyz_1e3g2_109",
  "input-type-search": "awsui_input-type-search_2rhyz_1e3g2_112",
  "input-has-icon-start": "awsui_input-has-icon-start_2rhyz_1e3g2_122",
  "input-has-icon-end": "awsui_input-has-icon-end_2rhyz_1e3g2_125",
  "input-container": "awsui_input-container_2rhyz_1e3g2_129",
  "input-field": "awsui_input-field_2rhyz_1e3g2_134",
  "input-field-readonly": "awsui_input-field-readonly_2rhyz_1e3g2_158",
  "input-field-disabled": "awsui_input-field-disabled_2rhyz_1e3g2_173",
  "input-field-invalid": "awsui_input-field-invalid_2rhyz_1e3g2_181",
  "input-field-warning": "awsui_input-field-warning_2rhyz_1e3g2_195",
  "input-field-no-border-radius": "awsui_input-field-no-border-radius_2rhyz_1e3g2_209",
  "input-field-no-border": "awsui_input-field-no-border_2rhyz_1e3g2_209",
  "grouped": "awsui_grouped_2rhyz_1e3g2_224",
  "grouped-with-error": "awsui_grouped-with-error_2rhyz_1e3g2_231",
  "grouped-with-warning": "awsui_grouped-with-warning_2rhyz_1e3g2_231",
  "grouped-disabled": "awsui_grouped-disabled_2rhyz_1e3g2_231",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_2rhyz_1e3g2_231",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_2rhyz_1e3g2_231",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_2rhyz_1e3g2_231",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_2rhyz_1e3g2_231",
  "grouped-vertical-first": "awsui_grouped-vertical-first_2rhyz_1e3g2_234",
  "grouped-vertical-only": "awsui_grouped-vertical-only_2rhyz_1e3g2_234",
  "grouped-vertical-last": "awsui_grouped-vertical-last_2rhyz_1e3g2_237",
  "grouped-row-first": "awsui_grouped-row-first_2rhyz_1e3g2_240",
  "grouped-with-action": "awsui_grouped-with-action_2rhyz_1e3g2_243",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_2rhyz_1e3g2_243",
  "input-prefix": "awsui_input-prefix_2rhyz_1e3g2_358",
  "input-suffix": "awsui_input-suffix_2rhyz_1e3g2_359",
  "input-adornment-content": "awsui_input-adornment-content_2rhyz_1e3g2_373",
  "input-adornment-divider": "awsui_input-adornment-divider_2rhyz_1e3g2_382",
  "input-icon-start": "awsui_input-icon-start_2rhyz_1e3g2_408",
  "input-icon-end": "awsui_input-icon-end_2rhyz_1e3g2_415",
  "input-button-right": "awsui_input-button-right_2rhyz_1e3g2_421",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_2rhyz_1e3g2_425",
  "inline-label-trigger-wrapper-full-width": "awsui_inline-label-trigger-wrapper-full-width_2rhyz_1e3g2_428",
  "inline-label-wrapper": "awsui_inline-label-wrapper_2rhyz_1e3g2_432",
  "inline-label-wrapper-full-width": "awsui_inline-label-wrapper-full-width_2rhyz_1e3g2_435",
  "inline-label": "awsui_inline-label_2rhyz_1e3g2_425",
  "inline-label-disabled": "awsui_inline-label-disabled_2rhyz_1e3g2_460"
};
  